import { Icon, Input, InputGroup, InputLeftElement, InputProps } from '@chakra-ui/react';
import { ChangeEvent } from 'react';
import { HiMagnifyingGlass } from 'react-icons/hi2';

type Props = InputProps & {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  rest?: InputProps;
};

export const DataTableSearch = ({ value, onChange, ...rest }: Props) => {
  return (
    <InputGroup maxW="sm" size="sm">
      <InputLeftElement pointerEvents="none" color="gray.600">
        <Icon as={HiMagnifyingGlass} />
      </InputLeftElement>
      <Input placeholder="Search" w="full" value={value} onChange={onChange} {...rest} />
    </InputGroup>
  );
};
